import { Editor, Node, Range } from 'slate';
import { ReactEditor } from 'slate-react';

export const isNodeFocused = (editor: Editor, node: Node) => {
    const path = ReactEditor.findPath(editor, node);
    const { selection } = editor;
    return !!selection && Range.isCollapsed(selection) && Range.includes(selection, path);
};
